import styled from "@emotion/styled";
import { FC } from "react";

import { HelpDeskColored, LiveChatColored } from "@livechat/design-system-icons";
import {
  DesignToken,
  Heading,
  Icon,
  Modal,
  RadiusToken,
  SpacingToken,
  Text,
  TransitionDurationToken,
  TransitionTimingToken,
} from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

type Props = {
  onClose(): void;
  onEditorClick(type: "form" | "widget"): void;
};

export const ContactFormChooser: FC<Props> = ({ onClose, onEditorClick }) => (
  <Modal onClose={onClose} heading="What type of contact form would you like to create?" css={{ width: "800px" }}>
    <Flex justifyContent="space-between" gap={withVar(SpacingToken.Spacing5)}>
      <Tile onClick={() => onEditorClick("form")}>
        <Icon source={HelpDeskColored} size="xxxlarge" />
        <Heading size="sm">Add HelpDesk contact form</Heading>
        <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>Contact form embedded on the website.</Text>
      </Tile>
      <Tile onClick={() => onEditorClick("widget")}>
        <Icon source={LiveChatColored} size="xxxlarge" />
        <Heading size="sm">Add LiveChat welcome screen form</Heading>
        <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>Contact form in the widget.</Text>
      </Tile>
    </Flex>
  </Modal>
);

const Tile = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(${SpacingToken.Spacing9}) var(${SpacingToken.Spacing5});
  gap: var(${SpacingToken.Spacing2});
  cursor: pointer;
  border-radius: var(${RadiusToken.Radius3});
  border: 1px solid var(${DesignToken.BorderBasicPrimary});
  transition: border-color var(${TransitionDurationToken.Fast2}) var(${TransitionTimingToken.EaseOut});

  &:hover {
    border-color: var(${DesignToken.BorderBasicHover});
  }
`;
